import { Client } from "@/Contracts/Clients";
import { Dispatch, Action, ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";
import { GlobalState } from "@/Reducers/interface";
import {
	Assessment,
	AddAssessmentRequest,
	AssessmentsRequest,
	AssessmentVulnerabilityData,
	AssessmentDataLog,
	EditAssessmentDataLogRequest,
	CreateCategoryRequest,
	ModifyCategoryRequest,
	ReorderCategoriesRequest,
	Ms365Assessment,
	AssessmentEditRequest
} from "@/Contracts/Assessments";
import {
	AssessmentBlocks,
	BlockMapper,
	BlockType,
	RiskListingBlockData
} from "@/Contracts/ProposalBuilder/Block";
import {
	addAssessment,
	getAssessments,
	getAssessmentDetails,
	editAssessmentDetails,
	resetRiskScore,
	getManualAssessmentDefaults,
	editAssessmentDataLog,
	addAssessmentDataLog,
	deleteAssessmentDataLog,
	getCategories,
	createCategory,
	updateCategory,
	deleteCategory,
	reorderCategories,
	getMs365Assessments,
	runMs365Assessment,
	previewMs365Assessment,
	insertMs365AssessmentIntoDocument,
	disconnectMs365Client
} from "@/Services/Assessments";
import { getBlock } from "@/ProposalBuilder/services/Block";
import { ClientsActionTypes } from "../Clients";
import {
	BlocksActionTypes,
	UpdateBlockMapperFailedAction,
	UpdateBlockMapperRequestedAction,
	UpdateBlockMapperSuccessfulAction
} from "@/ProposalBuilder/store/actions/Blocks";
import { proposalBuilderStore } from "@/ProposalBuilder/store";

export enum AssessmentsActionTypes {
	SHOW_ASSESSMENTS_LOADER = "SHOW_ASSESSMENTS_LOADER",
	HIDE_ASSESSMENTS_LOADER = "HIDE_ASSESSMENTS_LOADER",
	SHOW_ASSESSMENT_LOG_LOADER = "SHOW_ASSESSMENT_LOG_LOADER",
	HIDE_ASSESSMENT_LOG_LOADER = "HIDE_ASSESSMENT_LOG_LOADER",
	ADD_ASSESSMENT_REQUESTED = "ADD_ASSESSMENT_REQUESTED",
	ADD_ASSESSMENT_SUCCESSFUL = "ADD_ASSESSMENT_SUCCESSFUL",
	ADD_ASSESSMENT_FAILED = "ADD_ASSESSMENT_FAILED",
	ASSESSMENTS_REQUESTED = "ASSESSMENTS_REQUESTED",
	ASSESSMENTS_SUCCESSFUL = "ASSESSMENTS_SUCCESSFUL",
	ASSESSMENTS_FAILED = "ASSESSMENTS_FAILED",
	ASSESSMENT_DETAILS_REQUESTED = "ASSESSMENT_DETAILS_REQUESTED",
	ASSESSMENT_DETAILS_SUCCESSFUL = "ASSESSMENT_DETAILS_SUCCESSFUL",
	ASSESSMENT_DETAILS_FAILED = "ASSESSMENT_DETAILS_FAILED",
	EDIT_ASSESSMENTS_REQUESTED = "EDIT_ASSESSMENTS_REQUESTED",
	EDIT_ASSESSMENTS_SUCCESSFUL = "EDIT_ASSESSMENTS_SUCCESSFUL",
	EDIT_ASSESSMENTS_FAILED = "EDIT_ASSESSMENTS_FAILED",
	ASSESSMENTS_RESET = "ASSESSMENTS_RESET",
	ASSESSMENT_DETAILS_RESET = "ASSESSMENT_DETAILS_RESET",
	MANUAL_ASSESSMENT_DEFAULTS_REQUESTED = "MANUAL_ASSESSMENT_DEFAULTS_REQUESTED",
	MANUAL_ASSESSMENT_DEFAULTS_FAILED = "MANUAL_ASSESSMENT_DEFAULTS_FAILED",
	MANUAL_ASSESSMENT_DEFAULTS_SUCCESSFUL = "MANUAL_ASSESSMENT_DEFAULTS_SUCCESSFUL",
	EDIT_ASSESSMENT_DATA_LOG_REQUESTED = "EDIT_ASSESSMENT_DATA_LOG_REQUESTED",
	EDIT_ASSESSMENT_DATA_LOG_FAILED = "EDIT_ASSESSMENT_DATA_LOG_FAILED",
	EDIT_ASSESSMENT_DATA_LOG_SUCCESSFUL = "EDIT_ASSESSMENT_DATA_LOG_SUCCESSFUL",
	ADD_ASSESSMENT_DATA_LOG_REQUESTED = "ADD_ASSESSMENT_DATA_LOG_REQUESTED",
	ADD_ASSESSMENT_DATA_LOG_FAILED = "ADD_ASSESSMENT_DATA_LOG_FAILED",
	ADD_ASSESSMENT_DATA_LOG_SUCCESSFUL = "ADD_ASSESSMENT_DATA_LOG_SUCCESSFUL",
	DELETE_ASSESSMENT_DATA_LOG_REQUESTED = "DELETE_ASSESSMENT_DATA_LOG_REQUESTED",
	DELETE_ASSESSMENT_DATA_LOG_FAILED = "DELETE_ASSESSMENT_DATA_LOG_FAILED",
	DELETE_ASSESSMENT_DATA_LOG_SUCCESSFUL = "DELETE_ASSESSMENT_DATA_LOG_SUCCESSFUL",
	ASSESSMENT_CATEGORIES_REQUESTED = "ASSESSMENT_CATEGORIES_REQUESTED",
	ASSESSMENT_CATEGORIES_SUCCESSFUL = "ASSESSMENT_CATEGORIES_SUCCESSFUL",
	ASSESSMENT_CATEGORIES_FAILED = "ASSESSMENT_CATEGORIES_FAILED",
	CREATE_ASSESSMENT_CATEGORY_REQUESTED = "CREATE_ASSESSMENT_CATEGORY_REQUESTED",
	CREATE_ASSESSMENT_CATEGORY_SUCCESSFUL = "CREATE_ASSESSMENT_CATEGORY_SUCCESSFUL",
	CREATE_ASSESSMENT_CATEGORY_FAILED = "CREATE_ASSESSMENT_CATEGORY_FAILED",
	UPDATE_ASSESSMENT_CATEGORY_REQUESTED = "UPDATE_ASSESSMENT_CATEGORY_REQUESTED",
	UPDATE_ASSESSMENT_CATEGORY_SUCCESS = "UPDATE_ASSESSMENT_CATEGORY_SUCCESS",
	UPDATE_ASSESSMENT_CATEGORY_FAILED = "UPDATE_ASSESSMENT_CATEGORY_FAILED",
	DELETE_ASSESSMENT_CATEGORY_REQUESTED = "DELETE_ASSESSMENT_CATEGORY_REQUESTED",
	DELETE_ASSESSMENT_CATEGORY_SUCCESS = "DELETE_ASSESSMENT_CATEGORY_SUCCESS",
	DELETE_ASSESSMENT_CATEGORY_FAILED = "DELETE_ASSESSMENT_CATEGORY_FAILED",
	REORDER_ASSESSMENT_CATEGORIES_REQUESTED = "REORDER_ASSESSMENT_CATEGORIES_REQUESTED",
	REORDER_ASSESSMENT_CATEGORIES_SUCCESS = "REORDER_ASSESSMENT_CATEGORIES_SUCCESS",
	REORDER_ASSESSMENT_CATEGORIES_FAILED = "REORDER_ASSESSMENT_CATEGORIES_FAILED",
	SHOW_MS365_ASSESSMENTS_LOADER = "SHOW_MS365_ASSESSMENTS_LOADER",
	HIDE_MS365_ASSESSMENTS_LOADER = "HIDE_MS365_ASSESSMENTS_LOADER",
	MS365_ASSESSMENTS_MODAL_OPENED = "MS365_ASSESSMENTS_MODAL_OPENED",
	MS365_ASSESSMENTS_MODAL_CLOSED = "MS365_ASSESSMENTS_MODAL_CLOSED",
	MS365_ASSESSMENTS_LIST_REQUESTED = "MS365_ASSESSMENTS_LIST_REQUESTED",
	MS365_ASSESSMENTS_LIST_SUCCESS = "MS365_ASSESSMENTS_LIST_SUCCESS",
	MS365_ASSESSMENTS_LIST_FAILED = "MS365_ASSESSMENTS_LIST_FAILED",
	MS365_ASSESSMENTS_RESET = "MS365_ASSESSMENTS_RESET",
	GENERATE_MS365_ASSESSMENT_REQUESTED = "GENERATE_MS365_ASSESSMENT_REQUESTED",
	GENERATE_MS365_ASSESSMENT_SUCCESS = "GENERATE_MS365_ASSESSMENT_SUCCESS",
	GENERATE_MS365_ASSESSMENT_FAILED = "GENERATE_MS365_ASSESSMENT_FAILED",
	PREVIEW_MS365_ASSESSMENT_REQUESTED = "PREVIEW_MS365_ASSESSMENT_REQUESTED",
	PREVIEW_MS365_ASSESSMENT_SUCCESS = "PREVIEW_MS365_ASSESSMENT_SUCCESS",
	PREVIEW_MS365_ASSESSMENT_FAILED = "PREVIEW_MS365_ASSESSMENT_FAILED",
	QUEUE_MS365_ASSESSMENT_TO_ADD_TO_DOC = "QUEUE_MS365_ASSESSMENT_TO_ADD_TO_DOC",
	DEQUEUE_MS365_ASSESSMENT_TO_ADD_TO_DOC = "DEQUEUE_MS365_ASSESSMENT_TO_ADD_TO_DOC",
	INSERT_MS365_INTO_DOC_REQUESTED = "INSERT_MS365_INTO_DOC_REQUESTED",
	INSERT_MS365_INTO_DOC_SUCCESS = "INSERT_MS365_INTO_DOC_SUCCESS",
	INSERT_MS365_INTO_DOC_FAILED = "INSERT_MS365_INTO_DOC_FAILED"
}

export type ShowAssessmentsLoaderAction =
	Action<AssessmentsActionTypes.SHOW_ASSESSMENTS_LOADER>;
export type HideAssessmentsLoaderAction =
	Action<AssessmentsActionTypes.HIDE_ASSESSMENTS_LOADER>;
export type ShowAssessmentLogLoaderAction =
	Action<AssessmentsActionTypes.SHOW_ASSESSMENT_LOG_LOADER>;
export type HideAssessmentLogLoaderAction =
	Action<AssessmentsActionTypes.HIDE_ASSESSMENT_LOG_LOADER>;
export type AddAssessmentRequestedAction =
	Action<AssessmentsActionTypes.ADD_ASSESSMENT_REQUESTED>;
export interface AddAssessmentSuccessfulAction
	extends Action<AssessmentsActionTypes.ADD_ASSESSMENT_SUCCESSFUL> {
	readonly addAssessment: Assessment;
}
export type AddAssessmentFailedAction =
	Action<AssessmentsActionTypes.ADD_ASSESSMENT_FAILED>;
export type AssessmentsRequestedAction =
	Action<AssessmentsActionTypes.ASSESSMENTS_REQUESTED>;
export interface AssessmentsSuccessfulAction
	extends Action<AssessmentsActionTypes.ASSESSMENTS_SUCCESSFUL> {
	readonly assessmentList: Assessment[];
}
export type AssessmentsFailedAction =
	Action<AssessmentsActionTypes.ASSESSMENTS_FAILED>;
export type AssessmentDetailsRequestedAction =
	Action<AssessmentsActionTypes.ASSESSMENT_DETAILS_REQUESTED>;
export interface AssessmentDetailsSuccessfulAction
	extends Action<AssessmentsActionTypes.ASSESSMENT_DETAILS_SUCCESSFUL> {
	readonly currentActiveAssessment: Assessment;
}
export type AssessmentDetailsFailedAction =
	Action<AssessmentsActionTypes.ASSESSMENT_DETAILS_FAILED>;
export type EditAssessmentDetailsRequestedAction =
	Action<AssessmentsActionTypes.EDIT_ASSESSMENTS_REQUESTED>;
export interface EditAssessmentDetailsSuccessfulAction
	extends Action<AssessmentsActionTypes.EDIT_ASSESSMENTS_SUCCESSFUL> {
	readonly currentActiveAssessment: Assessment;
}
export type EditAssessmentDetailsFailedAction =
	Action<AssessmentsActionTypes.EDIT_ASSESSMENTS_FAILED>;
export type AssessmentsResetAction =
	Action<AssessmentsActionTypes.ASSESSMENTS_RESET>;
export type AssessmentDetailsResetAction =
	Action<AssessmentsActionTypes.ASSESSMENT_DETAILS_RESET>;

export type ManualAssessmentDefaultsRequestedAction =
	Action<AssessmentsActionTypes.MANUAL_ASSESSMENT_DEFAULTS_REQUESTED>;
export type ManualAssessmentDefaultsFailedAction =
	Action<AssessmentsActionTypes.MANUAL_ASSESSMENT_DEFAULTS_FAILED>;
export interface ManualAssessmentDefaultsSuccessfulAction
	extends Action<AssessmentsActionTypes.MANUAL_ASSESSMENT_DEFAULTS_SUCCESSFUL> {
	readonly manualAssessmentDefaults: AssessmentVulnerabilityData[];
}

export type EditAssessmentDataLogFailedAction =
	Action<AssessmentsActionTypes.EDIT_ASSESSMENT_DATA_LOG_FAILED>;
export type EditAssessmentDataLogRequestedAction =
	Action<AssessmentsActionTypes.EDIT_ASSESSMENT_DATA_LOG_REQUESTED>;
export interface EditAssessmentDataLogSuccessfulAction
	extends Action<AssessmentsActionTypes.EDIT_ASSESSMENT_DATA_LOG_SUCCESSFUL> {
	readonly editAssessmentLog: AssessmentDataLog;
}

export type AddAssessmentDataLogFailedAction =
	Action<AssessmentsActionTypes.ADD_ASSESSMENT_DATA_LOG_FAILED>;

export type AddAssessmentDataLogRequestedAction =
	Action<AssessmentsActionTypes.ADD_ASSESSMENT_DATA_LOG_REQUESTED>;

export interface AddAssessmentDataLogSuccessfulAction
	extends Action<AssessmentsActionTypes.ADD_ASSESSMENT_DATA_LOG_SUCCESSFUL> {
	readonly addAssessmentLog: AssessmentDataLog;
}

export type DeleteAssessmentDataLogRequestedAction =
	Action<AssessmentsActionTypes.DELETE_ASSESSMENT_DATA_LOG_REQUESTED>;

export type DeleteAssessmentDataLogFailedAction =
	Action<AssessmentsActionTypes.DELETE_ASSESSMENT_DATA_LOG_FAILED>;

export interface DeleteAssessmentDataLogSuccessfulAction
	extends Action<AssessmentsActionTypes.DELETE_ASSESSMENT_DATA_LOG_SUCCESSFUL> {
	readonly deleteAssessmentLog: AssessmentDataLog;
}
export type AssessmentCategoriesRequestedAction =
	Action<AssessmentsActionTypes.ASSESSMENT_CATEGORIES_REQUESTED>;
export interface AssessmentCategoriesSuccessfulAction
	extends Action<AssessmentsActionTypes.ASSESSMENT_CATEGORIES_SUCCESSFUL> {
	readonly currentActiveAssessment: Assessment;
}
export type AssessmentCategoriesFailedAction =
	Action<AssessmentsActionTypes.ASSESSMENT_CATEGORIES_FAILED>;

export type CreateCategoryRequestedAction =
	Action<AssessmentsActionTypes.CREATE_ASSESSMENT_CATEGORY_REQUESTED>;

export interface CreateCategorySuccessfulAction
	extends Action<AssessmentsActionTypes.CREATE_ASSESSMENT_CATEGORY_SUCCESSFUL> {
	readonly currentActiveAssessment: Assessment;
}

export type CreateCategoryFailedAction =
	Action<AssessmentsActionTypes.CREATE_ASSESSMENT_CATEGORY_FAILED>;

export type UpdateCategoryRequestedAction =
	Action<AssessmentsActionTypes.UPDATE_ASSESSMENT_CATEGORY_REQUESTED>;
export interface UpdateCategorySuccessfulAction
	extends Action<AssessmentsActionTypes.UPDATE_ASSESSMENT_CATEGORY_SUCCESS> {
	readonly currentActiveAssessment: Assessment;
}
export type UpdateCategoryFailedAction =
	Action<AssessmentsActionTypes.UPDATE_ASSESSMENT_CATEGORY_FAILED>;

export type DeleteCategoryRequestedAction =
	Action<AssessmentsActionTypes.DELETE_ASSESSMENT_CATEGORY_REQUESTED>;
export interface DeleteCategorySuccessfulAction
	extends Action<AssessmentsActionTypes.DELETE_ASSESSMENT_CATEGORY_SUCCESS> {
	readonly currentActiveAssessment: Assessment;
}
export type DeleteCategoryFailedAction =
	Action<AssessmentsActionTypes.DELETE_ASSESSMENT_CATEGORY_FAILED>;

export type ReorderCategoryRequestedAction =
	Action<AssessmentsActionTypes.REORDER_ASSESSMENT_CATEGORIES_REQUESTED>;
export interface ReorderCategoriesSuccessfulAction
	extends Action<AssessmentsActionTypes.REORDER_ASSESSMENT_CATEGORIES_SUCCESS> {
	readonly currentActiveAssessment: Assessment;
}
export type ReorderCategoryFailedAction =
	Action<AssessmentsActionTypes.REORDER_ASSESSMENT_CATEGORIES_FAILED>;

export type ShowMs365AssessmentsLoaderAction =
	Action<AssessmentsActionTypes.SHOW_MS365_ASSESSMENTS_LOADER>;
export type HideMs365AssessmentsLoaderAction =
	Action<AssessmentsActionTypes.HIDE_MS365_ASSESSMENTS_LOADER>;

export type Ms365AssessmentModalOpenedAction =
	Action<AssessmentsActionTypes.MS365_ASSESSMENTS_MODAL_OPENED>;
export type Ms365AssessmentModalClosedAction =
	Action<AssessmentsActionTypes.MS365_ASSESSMENTS_MODAL_CLOSED>;

export type Ms365AssessmentsListRequestedAction =
	Action<AssessmentsActionTypes.MS365_ASSESSMENTS_LIST_REQUESTED>;
export interface Ms365AssessmentsListSuccessfulAction
	extends Action<AssessmentsActionTypes.MS365_ASSESSMENTS_LIST_SUCCESS> {
	readonly ms365AssessmentsList: Ms365Assessment[];
}
export type Ms365AssessmentsListFailedAction =
	Action<AssessmentsActionTypes.MS365_ASSESSMENTS_LIST_FAILED>;

export type Ms365AssessmentsResetAction =
	Action<AssessmentsActionTypes.MS365_ASSESSMENTS_RESET>;

export type GenerateMs365AssessmentRequestedAction =
	Action<AssessmentsActionTypes.GENERATE_MS365_ASSESSMENT_REQUESTED>;
export interface GenerateMs365AssessmentSuccessfulAction
	extends Action<AssessmentsActionTypes.GENERATE_MS365_ASSESSMENT_SUCCESS> {
	readonly currentActiveMs365Assessment: Ms365Assessment;
}
export type GenerateMs365AssessmentFailedAction =
	Action<AssessmentsActionTypes.GENERATE_MS365_ASSESSMENT_FAILED>;

export type PreviewMs365AssessmentRequestedAction =
	Action<AssessmentsActionTypes.PREVIEW_MS365_ASSESSMENT_REQUESTED>;
export interface PreviewMs365AssessmentSuccessfulAction
	extends Action<AssessmentsActionTypes.PREVIEW_MS365_ASSESSMENT_SUCCESS> {
	readonly currentActiveMs365Assessment: Ms365Assessment;
}
export type PreviewMs365AssessmentFailedAction =
	Action<AssessmentsActionTypes.PREVIEW_MS365_ASSESSMENT_FAILED>;

export interface QueueMs65AssessmentToAddToDocAction
	extends Action<AssessmentsActionTypes.QUEUE_MS365_ASSESSMENT_TO_ADD_TO_DOC> {
	readonly ms365AssessmentId: string;
}
export type DequeueMs365AssessmentToAddToDocAction =
	Action<AssessmentsActionTypes.DEQUEUE_MS365_ASSESSMENT_TO_ADD_TO_DOC>;

export type InsertMs365IntoDocRequestedAction =
	Action<AssessmentsActionTypes.INSERT_MS365_INTO_DOC_REQUESTED>;
export interface InsertMs365IntoDocSuccessfulAction
	extends Action<AssessmentsActionTypes.INSERT_MS365_INTO_DOC_SUCCESS> {
	readonly currentActiveAssessment: Assessment;
}
export type InsertMs365IntoDocFailedAction =
	Action<AssessmentsActionTypes.INSERT_MS365_INTO_DOC_FAILED>;

export interface DisconnectMs365ClientAction
	extends Action<ClientsActionTypes.CLIENT_DETAILS_SUCCESSFUL> {
	readonly currentActiveClient: Client;
}

export type AssessmentsActions =
	| ShowAssessmentsLoaderAction
	| HideAssessmentsLoaderAction
	| ShowAssessmentLogLoaderAction
	| HideAssessmentLogLoaderAction
	| AddAssessmentRequestedAction
	| AddAssessmentSuccessfulAction
	| AddAssessmentFailedAction
	| AssessmentsRequestedAction
	| AssessmentDetailsRequestedAction
	| AssessmentsSuccessfulAction
	| AssessmentDetailsSuccessfulAction
	| AssessmentsFailedAction
	| AssessmentDetailsFailedAction
	| EditAssessmentDetailsRequestedAction
	| EditAssessmentDetailsSuccessfulAction
	| EditAssessmentDetailsFailedAction
	| AssessmentsResetAction
	| AssessmentDetailsResetAction
	| ManualAssessmentDefaultsRequestedAction
	| ManualAssessmentDefaultsFailedAction
	| ManualAssessmentDefaultsSuccessfulAction
	| EditAssessmentDataLogFailedAction
	| EditAssessmentDataLogRequestedAction
	| EditAssessmentDataLogSuccessfulAction
	| AddAssessmentDataLogFailedAction
	| AddAssessmentDataLogRequestedAction
	| AddAssessmentDataLogSuccessfulAction
	| DeleteAssessmentDataLogFailedAction
	| DeleteAssessmentDataLogRequestedAction
	| DeleteAssessmentDataLogSuccessfulAction
	| AssessmentCategoriesRequestedAction
	| AssessmentCategoriesSuccessfulAction
	| AssessmentCategoriesFailedAction
	| CreateCategoryRequestedAction
	| CreateCategorySuccessfulAction
	| CreateCategoryFailedAction
	| UpdateCategoryRequestedAction
	| UpdateCategorySuccessfulAction
	| UpdateCategoryFailedAction
	| DeleteCategoryRequestedAction
	| DeleteCategorySuccessfulAction
	| DeleteCategoryFailedAction
	| ReorderCategoryRequestedAction
	| ReorderCategoriesSuccessfulAction
	| ReorderCategoryFailedAction
	| ShowMs365AssessmentsLoaderAction
	| HideMs365AssessmentsLoaderAction
	| Ms365AssessmentModalOpenedAction
	| Ms365AssessmentModalClosedAction
	| Ms365AssessmentsListRequestedAction
	| Ms365AssessmentsListSuccessfulAction
	| Ms365AssessmentsListFailedAction
	| Ms365AssessmentsResetAction
	| GenerateMs365AssessmentRequestedAction
	| GenerateMs365AssessmentSuccessfulAction
	| GenerateMs365AssessmentFailedAction
	| PreviewMs365AssessmentRequestedAction
	| PreviewMs365AssessmentSuccessfulAction
	| PreviewMs365AssessmentFailedAction
	| QueueMs65AssessmentToAddToDocAction
	| DequeueMs365AssessmentToAddToDocAction
	| InsertMs365IntoDocRequestedAction
	| InsertMs365IntoDocSuccessfulAction
	| InsertMs365IntoDocFailedAction
	| DisconnectMs365ClientAction;

interface AssessmentDataLogRequest<T> {
	requestPayload: T;
	updateAssessmentBlocks: boolean;
}

export interface AssessmentsDispatch {
	showAssessmentsLoader: ActionCreator<
		ThunkAction<
			ShowAssessmentsLoaderAction,
			GlobalState,
			null,
			ShowAssessmentsLoaderAction
		>
	>;
	hideAssessmentsLoader: ActionCreator<
		ThunkAction<
			HideAssessmentsLoaderAction,
			GlobalState,
			null,
			HideAssessmentsLoaderAction
		>
	>;
	showAssessmentLogLoader: ActionCreator<
		ThunkAction<
			ShowAssessmentLogLoaderAction,
			GlobalState,
			null,
			ShowAssessmentLogLoaderAction
		>
	>;
	hideAssessmentLogLoader: ActionCreator<
		ThunkAction<
			HideAssessmentLogLoaderAction,
			GlobalState,
			null,
			HideAssessmentLogLoaderAction
		>
	>;
	addAssessment: ActionCreator<
		ThunkAction<
			Promise<AddAssessmentSuccessfulAction>,
			GlobalState,
			AddAssessmentRequest,
			AddAssessmentSuccessfulAction
		>
	>;
	getAssessmentDetails: ActionCreator<
		ThunkAction<
			Promise<AssessmentDetailsSuccessfulAction>,
			GlobalState,
			string,
			AssessmentDetailsSuccessfulAction
		>
	>;
	editAssessmentDetails: ActionCreator<
		ThunkAction<
			Promise<EditAssessmentDetailsSuccessfulAction>,
			GlobalState,
			Assessment,
			EditAssessmentDetailsSuccessfulAction
		>
	>;
	resetRiskScore: ActionCreator<
		ThunkAction<
			Promise<EditAssessmentDetailsSuccessfulAction>,
			GlobalState,
			string,
			EditAssessmentDetailsSuccessfulAction
		>
	>;
	getAssessments: ActionCreator<
		ThunkAction<
			Promise<AssessmentsSuccessfulAction>,
			GlobalState,
			AssessmentsRequest,
			AssessmentsSuccessfulAction
		>
	>;
	resetAssessments: ActionCreator<
		ThunkAction<
			AssessmentsResetAction,
			GlobalState,
			null,
			AssessmentsResetAction
		>
	>;
	resetAssessmentDetails: ActionCreator<
		ThunkAction<
			AssessmentDetailsResetAction,
			GlobalState,
			null,
			AssessmentDetailsResetAction
		>
	>;
	getManualAssesmentDefaults: ActionCreator<
		ThunkAction<
			Promise<ManualAssessmentDefaultsSuccessfulAction>,
			GlobalState,
			null,
			ManualAssessmentDefaultsSuccessfulAction
		>
	>;
	editAssessmentDataLog: ActionCreator<
		ThunkAction<
			Promise<EditAssessmentDataLogSuccessfulAction>,
			GlobalState,
			AssessmentDataLogRequest<EditAssessmentDataLogRequest>,
			EditAssessmentDataLogSuccessfulAction
		>
	>;
	addAssessmentDataLog: ActionCreator<
		ThunkAction<
			Promise<AddAssessmentDataLogSuccessfulAction>,
			GlobalState,
			AssessmentDataLogRequest<AssessmentDataLog>,
			AddAssessmentDataLogSuccessfulAction
		>
	>;
	deleteAssessmentDataLog: ActionCreator<
		ThunkAction<
			Promise<DeleteAssessmentDataLogSuccessfulAction>,
			GlobalState,
			AssessmentDataLog,
			DeleteAssessmentDataLogSuccessfulAction
		>
	>;
	getCategories: ActionCreator<
		ThunkAction<
			Promise<AssessmentCategoriesSuccessfulAction>,
			GlobalState,
			string,
			AssessmentCategoriesSuccessfulAction
		>
	>;
	createCategory: ActionCreator<
		ThunkAction<
			Promise<CreateCategorySuccessfulAction>,
			GlobalState,
			CreateCategoryRequest,
			CreateCategorySuccessfulAction
		>
	>;
	updateCategory: ActionCreator<
		ThunkAction<
			Promise<UpdateCategorySuccessfulAction>,
			GlobalState,
			ModifyCategoryRequest,
			UpdateCategorySuccessfulAction
		>
	>;
	deleteCategory: ActionCreator<
		ThunkAction<
			Promise<DeleteCategorySuccessfulAction>,
			GlobalState,
			ModifyCategoryRequest,
			DeleteCategorySuccessfulAction
		>
	>;
	reorderCategories: ActionCreator<
		ThunkAction<
			Promise<ReorderCategoriesSuccessfulAction>,
			GlobalState,
			ReorderCategoriesRequest,
			ReorderCategoriesSuccessfulAction
		>
	>;
	showMs365AssessmentsLoader: ActionCreator<
		ThunkAction<
			ShowMs365AssessmentsLoaderAction,
			GlobalState,
			null,
			ShowMs365AssessmentsLoaderAction
		>
	>;
	hideMs365AssessmentsLoader: ActionCreator<
		ThunkAction<
			HideMs365AssessmentsLoaderAction,
			GlobalState,
			null,
			HideMs365AssessmentsLoaderAction
		>
	>;
	openMs365AssessmentModal: ActionCreator<
		ThunkAction<
			Ms365AssessmentModalOpenedAction,
			GlobalState,
			null,
			Ms365AssessmentModalOpenedAction
		>
	>;
	closeMs365AssessmentModal: ActionCreator<
		ThunkAction<
			Ms365AssessmentModalClosedAction,
			GlobalState,
			null,
			Ms365AssessmentModalClosedAction
		>
	>;
	getMs365Assessments: ActionCreator<
		ThunkAction<
			Promise<Ms365AssessmentsListSuccessfulAction>,
			GlobalState,
			string,
			Ms365AssessmentsListSuccessfulAction
		>
	>;
	resetMs365Assessments: ActionCreator<
		ThunkAction<
			Ms365AssessmentsResetAction,
			GlobalState,
			null,
			Ms365AssessmentsResetAction
		>
	>;
	generateMs365Assessment: ActionCreator<
		ThunkAction<
			Promise<GenerateMs365AssessmentSuccessfulAction>,
			GlobalState,
			string,
			GenerateMs365AssessmentSuccessfulAction
		>
	>;
	previewMs365Assessment: ActionCreator<
		ThunkAction<
			Promise<PreviewMs365AssessmentSuccessfulAction>,
			GlobalState,
			{ clientId: string; ms365AssessmentId: string },
			PreviewMs365AssessmentSuccessfulAction
		>
	>;
	queueMs365AssessmentToAddToDoc: ActionCreator<
		ThunkAction<
			QueueMs65AssessmentToAddToDocAction,
			GlobalState,
			string,
			QueueMs65AssessmentToAddToDocAction
		>
	>;
	dequeueMs365AssessmentToAddToDoc: ActionCreator<
		ThunkAction<
			DequeueMs365AssessmentToAddToDocAction,
			GlobalState,
			null,
			DequeueMs365AssessmentToAddToDocAction
		>
	>;
	insertMs365AssessmentIntoDocument: ActionCreator<
		ThunkAction<
			Promise<InsertMs365IntoDocSuccessfulAction>,
			GlobalState,
			{ entityId: string; ms365AssessmentId: string },
			InsertMs365IntoDocSuccessfulAction
		>
	>;
	disconnectMs365Client: ActionCreator<
		ThunkAction<
			Promise<DisconnectMs365ClientAction>,
			GlobalState,
			string,
			DisconnectMs365ClientAction
		>
	>;
}

const getUpdatedAssessmentBlocks = async (
	_state: GlobalState,
	{ riskMatrix, riskScore, riskListing }: AssessmentBlocks,
	riskListingBlocksCategoryIdList?: string[]
) => {
	const proposalBuilderState = proposalBuilderStore.getState();
	const riskMatrixBlock = Object.values(
		proposalBuilderState.blocks.blockMapper
	).filter(block => block.type === BlockType.RISK_MATRIX);
	const riskBarBlock = Object.values(
		proposalBuilderState.blocks.blockMapper
	).filter(block => block.type === BlockType.RISK_BAR);
	const riskListingBlocks = Object.values(
		proposalBuilderState.blocks.blockMapper
	).filter(block => {
		const blockTypeMatch = block.type === BlockType.RISK_LISTING;
		const blockData = block.data as RiskListingBlockData;

		return riskListingBlocksCategoryIdList?.length
			? blockTypeMatch &&
					riskListingBlocksCategoryIdList?.includes(
						blockData.category_id
					)
			: blockTypeMatch;
	});

	let newBlockMapper = { ...proposalBuilderState.blocks.blockMapper };
	// fetch new risk matrix
	if (riskMatrixBlock[0]?.id && riskMatrix) {
		const newRiskMatrix = await getBlock(riskMatrixBlock[0].id);
		newBlockMapper = {
			...newBlockMapper,
			[newRiskMatrix.id]: newRiskMatrix
		};
	}

	// fetch new risk bar
	if (riskBarBlock[0]?.id && riskScore) {
		const newRiskBar = await getBlock(riskBarBlock[0].id);
		newBlockMapper = { ...newBlockMapper, [newRiskBar.id]: newRiskBar };
	}

	// fetch new risk listing
	for (let i = 0; i < riskListingBlocks.length; i++) {
		if (riskListingBlocks[i]?.id && riskListing) {
			const newRiskListing = await getBlock(riskListingBlocks[i].id);
			newBlockMapper = {
				...newBlockMapper,
				[newRiskListing.id]: newRiskListing
			};
		}
	}

	return newBlockMapper;
};

const reloadPageToUpdateBlocks = (blockMapper: BlockMapper) => {
	const riskListingBlock = Object.values(blockMapper).filter(
		block => block.type === BlockType.RISK_LISTING
	);
	if (riskListingBlock[0]?.id) {
		const data = riskListingBlock[0].data as RiskListingBlockData;
		if (!data?.category_id) {
			window.location.reload();
		}
	}
};

export const AssessmentsActionCreators: AssessmentsDispatch = {
	showAssessmentsLoader: () => {
		return (dispatch: Dispatch): ShowAssessmentsLoaderAction => {
			const showAssessmentsLoaderAction: ShowAssessmentsLoaderAction = {
				type: AssessmentsActionTypes.SHOW_ASSESSMENTS_LOADER
			};
			return dispatch(showAssessmentsLoaderAction);
		};
	},
	hideAssessmentsLoader: () => {
		return (dispatch: Dispatch): HideAssessmentsLoaderAction => {
			const hideAssessmentsLoaderAction: HideAssessmentsLoaderAction = {
				type: AssessmentsActionTypes.HIDE_ASSESSMENTS_LOADER
			};
			return dispatch(hideAssessmentsLoaderAction);
		};
	},
	showAssessmentLogLoader: () => {
		return (dispatch: Dispatch): ShowAssessmentLogLoaderAction => {
			const showAssessmentLogLoaderAction: ShowAssessmentLogLoaderAction =
				{
					type: AssessmentsActionTypes.SHOW_ASSESSMENT_LOG_LOADER
				};
			return dispatch(showAssessmentLogLoaderAction);
		};
	},
	hideAssessmentLogLoader: () => {
		return (dispatch: Dispatch): HideAssessmentLogLoaderAction => {
			const hideAssessmentLogLoaderAction: HideAssessmentLogLoaderAction =
				{
					type: AssessmentsActionTypes.HIDE_ASSESSMENT_LOG_LOADER
				};
			return dispatch(hideAssessmentLogLoaderAction);
		};
	},
	addAssessment: (addAssessmentRequest: AddAssessmentRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<AddAssessmentSuccessfulAction> => {
			const addAssessmentRequestedAction: AddAssessmentRequestedAction = {
				type: AssessmentsActionTypes.ADD_ASSESSMENT_REQUESTED
			};
			dispatch(addAssessmentRequestedAction);
			try {
				const addAssessmentResponse = await addAssessment(
					addAssessmentRequest
				);
				const addAssessmentSuccessfulAction: AddAssessmentSuccessfulAction =
					{
						type: AssessmentsActionTypes.ADD_ASSESSMENT_SUCCESSFUL,
						addAssessment: addAssessmentResponse
					};
				return dispatch(addAssessmentSuccessfulAction);
			} catch (error) {
				const addAssessmentFailedAction: AddAssessmentFailedAction = {
					type: AssessmentsActionTypes.ADD_ASSESSMENT_FAILED
				};
				dispatch(addAssessmentFailedAction);

				return Promise.reject(error);
			}
		};
	},
	getAssessments: (assessmentsRequest: AssessmentsRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<AssessmentsSuccessfulAction> => {
			const assessmentsRequestedAction: AssessmentsRequestedAction = {
				type: AssessmentsActionTypes.ASSESSMENTS_REQUESTED
			};
			dispatch(assessmentsRequestedAction);
			try {
				const assessmentsResponse = await getAssessments(
					assessmentsRequest
				);
				const assessmentsSuccessfulAction: AssessmentsSuccessfulAction =
					{
						type: AssessmentsActionTypes.ASSESSMENTS_SUCCESSFUL,
						assessmentList: assessmentsResponse.data
					};
				return dispatch(assessmentsSuccessfulAction);
			} catch (error) {
				const assessmentsFailedAction: AssessmentsFailedAction = {
					type: AssessmentsActionTypes.ASSESSMENTS_FAILED
				};
				dispatch(assessmentsFailedAction);

				return Promise.reject(error);
			}
		};
	},
	getAssessmentDetails: (
		assessmentId: string,
		appendQueryParamAuth = false
	) => {
		return async (
			dispatch: Dispatch
		): Promise<AssessmentDetailsSuccessfulAction> => {
			const assessmentDetailsRequestedAction: AssessmentDetailsRequestedAction =
				{
					type: AssessmentsActionTypes.ASSESSMENT_DETAILS_REQUESTED
				};
			dispatch(assessmentDetailsRequestedAction);
			try {
				const assessmentDetailsResponse = await getAssessmentDetails(
					assessmentId,
					appendQueryParamAuth
				);
				const assessmentDetailsSuccessfulAction: AssessmentDetailsSuccessfulAction =
					{
						type: AssessmentsActionTypes.ASSESSMENT_DETAILS_SUCCESSFUL,
						currentActiveAssessment: assessmentDetailsResponse
					};
				return dispatch(assessmentDetailsSuccessfulAction);
			} catch (error) {
				const assessmentDetailsFailedAction: AssessmentDetailsFailedAction =
					{
						type: AssessmentsActionTypes.ASSESSMENT_DETAILS_FAILED
					};
				dispatch(assessmentDetailsFailedAction);

				return Promise.reject(error);
			}
		};
	},
	editAssessmentDetails: (assessment: Assessment) => {
		return async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<EditAssessmentDetailsSuccessfulAction> => {
			const editAssessmentDetailsRequestedActions: EditAssessmentDetailsRequestedAction =
				{
					type: AssessmentsActionTypes.EDIT_ASSESSMENTS_REQUESTED
				};
			dispatch(editAssessmentDetailsRequestedActions);
			try {
				const assessmentEditData: AssessmentEditRequest = {
					severity_labels: assessment.severity_labels,
					legend_labels: assessment.legend_labels,
					severity_header_label: assessment.severity_header_label,
					likelihood_header_label: assessment.likelihood_header_label,
					risk_bar_score: assessment.risk_bar_score,
					likelihood_labels: assessment.likelihood_labels
				};
				const editAssessmentDetailsResponse =
					await editAssessmentDetails(assessment, assessmentEditData);
				const updateBlockMapperRequestedAction: UpdateBlockMapperRequestedAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_REQUESTED
					};
				proposalBuilderStore.dispatch(updateBlockMapperRequestedAction);
				try {
					const state = getState();
					const newBlockMapper = await getUpdatedAssessmentBlocks(
						state,
						{
							riskMatrix: true,
							riskScore: true,
							riskListing: false
						}
					);
					const updateBlockMapperSuccessfulAction: UpdateBlockMapperSuccessfulAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_SUCCESSFUL,
							blockMapper: newBlockMapper
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperSuccessfulAction
					);
					const proposalBuilderState =
						proposalBuilderStore.getState();
					reloadPageToUpdateBlocks(
						proposalBuilderState.blocks.blockMapper
					);
				} catch (error) {
					const updateBlockMapperFailedAction: UpdateBlockMapperFailedAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_FAILED
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperFailedAction
					);

					return Promise.reject(error);
				}
				const assessmentDetailsSuccessfulAction: EditAssessmentDetailsSuccessfulAction =
					{
						type: AssessmentsActionTypes.EDIT_ASSESSMENTS_SUCCESSFUL,
						currentActiveAssessment: editAssessmentDetailsResponse
					};
				return dispatch(assessmentDetailsSuccessfulAction);
			} catch (error) {
				const editAssessmentDetailsFailedAction: EditAssessmentDetailsFailedAction =
					{
						type: AssessmentsActionTypes.EDIT_ASSESSMENTS_FAILED
					};
				dispatch(editAssessmentDetailsFailedAction);

				return Promise.reject(error);
			}
		};
	},
	resetRiskScore: (assessmentId: string) => {
		return async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<EditAssessmentDetailsSuccessfulAction> => {
			const editAssessmentDetailsRequestedActions: EditAssessmentDetailsRequestedAction =
				{
					type: AssessmentsActionTypes.EDIT_ASSESSMENTS_REQUESTED
				};
			dispatch(editAssessmentDetailsRequestedActions);
			try {
				const editAssessmentDetailsResponse = await resetRiskScore(
					assessmentId
				);
				const updateBlockMapperRequestedAction: UpdateBlockMapperRequestedAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_REQUESTED
					};
				proposalBuilderStore.dispatch(updateBlockMapperRequestedAction);
				try {
					const state = getState();
					const newBlockMapper = await getUpdatedAssessmentBlocks(
						state,
						{
							riskMatrix: false,
							riskScore: true,
							riskListing: false
						}
					);

					const updateBlockMapperSuccessfulAction: UpdateBlockMapperSuccessfulAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_SUCCESSFUL,
							blockMapper: newBlockMapper
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperSuccessfulAction
					);
				} catch (error) {
					const updateBlockMapperFailedAction: UpdateBlockMapperFailedAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_FAILED
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperFailedAction
					);

					return Promise.reject(error);
				}
				const editAssessmentDetailsSuccessfulAction: EditAssessmentDetailsSuccessfulAction =
					{
						type: AssessmentsActionTypes.EDIT_ASSESSMENTS_SUCCESSFUL,
						currentActiveAssessment: editAssessmentDetailsResponse
					};
				return dispatch(editAssessmentDetailsSuccessfulAction);
			} catch (error) {
				const editAssessmentDetailsFailedAction: EditAssessmentDetailsFailedAction =
					{
						type: AssessmentsActionTypes.EDIT_ASSESSMENTS_FAILED
					};
				dispatch(editAssessmentDetailsFailedAction);

				return Promise.reject(error);
			}
		};
	},
	resetAssessments: () => {
		return (dispatch: Dispatch): AssessmentsResetAction => {
			const assessmentsResetAction: AssessmentsResetAction = {
				type: AssessmentsActionTypes.ASSESSMENTS_RESET
			};
			return dispatch(assessmentsResetAction);
		};
	},
	resetAssessmentDetails: () => {
		return (dispatch: Dispatch): AssessmentDetailsResetAction => {
			const assessmentDetailsResetAction: AssessmentDetailsResetAction = {
				type: AssessmentsActionTypes.ASSESSMENT_DETAILS_RESET
			};
			return dispatch(assessmentDetailsResetAction);
		};
	},
	getManualAssesmentDefaults: () => {
		return async (
			dispatch: Dispatch
		): Promise<ManualAssessmentDefaultsSuccessfulAction> => {
			const manualAssessmentDefaultsRequestedAction: ManualAssessmentDefaultsRequestedAction =
				{
					type: AssessmentsActionTypes.MANUAL_ASSESSMENT_DEFAULTS_REQUESTED
				};
			dispatch(manualAssessmentDefaultsRequestedAction);
			try {
				const manualAssessmentDefaultsResponse =
					await getManualAssessmentDefaults();
				const manualAssessmentDefaultsSuccessfulAction: ManualAssessmentDefaultsSuccessfulAction =
					{
						type: AssessmentsActionTypes.MANUAL_ASSESSMENT_DEFAULTS_SUCCESSFUL,
						manualAssessmentDefaults:
							manualAssessmentDefaultsResponse
					};
				return dispatch(manualAssessmentDefaultsSuccessfulAction);
			} catch (error) {
				const manualAssessmentDefaultsFailedAction: ManualAssessmentDefaultsFailedAction =
					{
						type: AssessmentsActionTypes.MANUAL_ASSESSMENT_DEFAULTS_FAILED
					};
				dispatch(manualAssessmentDefaultsFailedAction);

				return Promise.reject(error);
			}
		};
	},
	editAssessmentDataLog: (
		editAssessmentLogRequest: EditAssessmentDataLogRequest,
		updateAssessmentBlocks = true
	) => {
		return async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<EditAssessmentDataLogSuccessfulAction> => {
			const editAssessmentDataLogRequestedAction: EditAssessmentDataLogRequestedAction =
				{
					type: AssessmentsActionTypes.EDIT_ASSESSMENT_DATA_LOG_REQUESTED
				};
			dispatch(editAssessmentDataLogRequestedAction);
			try {
				const state = getState();
				const assessmentId =
					state.assessments.currentActiveAssessment?.id;
				if (!assessmentId) {
					throw new Error(
						"Assessment Data Log update without currentActiveAssessment"
					);
				}
				const editAssessmentLogResponse = await editAssessmentDataLog(
					editAssessmentLogRequest,
					assessmentId
				);
				if (updateAssessmentBlocks) {
					const updateBlockMapperRequestedAction: UpdateBlockMapperRequestedAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_REQUESTED
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperRequestedAction
					);
					try {
						const state = getState();
						const proposalBuilderState =
							proposalBuilderStore.getState();
						reloadPageToUpdateBlocks(
							proposalBuilderState.blocks.blockMapper
						);
						const newBlockMapper = await getUpdatedAssessmentBlocks(
							state,
							{
								riskMatrix: true,
								riskScore: true,
								riskListing: true
							}
						);
						const updateBlockMapperSuccessfulAction: UpdateBlockMapperSuccessfulAction =
							{
								type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_SUCCESSFUL,
								blockMapper: newBlockMapper
							};
						proposalBuilderStore.dispatch(
							updateBlockMapperSuccessfulAction
						);
					} catch (error) {
						const updateBlockMapperFailedAction: UpdateBlockMapperFailedAction =
							{
								type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_FAILED
							};
						proposalBuilderStore.dispatch(
							updateBlockMapperFailedAction
						);

						return Promise.reject(error);
					}
				}
				const editAssessmentDataLogSuccessfulAction: EditAssessmentDataLogSuccessfulAction =
					{
						type: AssessmentsActionTypes.EDIT_ASSESSMENT_DATA_LOG_SUCCESSFUL,
						editAssessmentLog: editAssessmentLogResponse
					};
				return dispatch(editAssessmentDataLogSuccessfulAction);
			} catch (error) {
				const editAssessmentLogFailedAction: EditAssessmentDataLogFailedAction =
					{
						type: AssessmentsActionTypes.EDIT_ASSESSMENT_DATA_LOG_FAILED
					};
				dispatch(editAssessmentLogFailedAction);

				return Promise.reject(error);
			}
		};
	},
	addAssessmentDataLog: (
		assessmentLog: AssessmentDataLog,
		updateAssessmentBlocks = true
	) => {
		return async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<AddAssessmentDataLogSuccessfulAction> => {
			const addAssessmentDataLogRequestedAction: AddAssessmentDataLogRequestedAction =
				{
					type: AssessmentsActionTypes.ADD_ASSESSMENT_DATA_LOG_REQUESTED
				};
			dispatch(addAssessmentDataLogRequestedAction);
			try {
				const state = getState();
				const assessmentId =
					state.assessments.currentActiveAssessment?.id;
				if (!assessmentId) {
					throw new Error(
						"Assessment Data Log add without currentActiveAssessment"
					);
				}
				const addAssessmentDataLogResponse = await addAssessmentDataLog(
					assessmentLog,
					assessmentId
				);
				if (updateAssessmentBlocks) {
					const updateBlockMapperRequestedAction: UpdateBlockMapperRequestedAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_REQUESTED
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperRequestedAction
					);
					try {
						const state = getState();
						const newBlockMapper = await getUpdatedAssessmentBlocks(
							state,
							{
								riskMatrix: true,
								riskScore: true,
								riskListing: true
							}
						);
						const updateBlockMapperSuccessfulAction: UpdateBlockMapperSuccessfulAction =
							{
								type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_SUCCESSFUL,
								blockMapper: newBlockMapper
							};
						proposalBuilderStore.dispatch(
							updateBlockMapperSuccessfulAction
						);
						const proposalBuilderState =
							proposalBuilderStore.getState();
						reloadPageToUpdateBlocks(
							proposalBuilderState.blocks.blockMapper
						);
					} catch (error) {
						const updateBlockMapperFailedAction: UpdateBlockMapperFailedAction =
							{
								type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_FAILED
							};
						proposalBuilderStore.dispatch(
							updateBlockMapperFailedAction
						);

						return Promise.reject(error);
					}
				}
				const addAssessmentDataLogSuccessfulAction: AddAssessmentDataLogSuccessfulAction =
					{
						type: AssessmentsActionTypes.ADD_ASSESSMENT_DATA_LOG_SUCCESSFUL,
						addAssessmentLog: addAssessmentDataLogResponse
					};
				return dispatch(addAssessmentDataLogSuccessfulAction);
			} catch (error) {
				const addAssessmentLogFailedAction: AddAssessmentDataLogFailedAction =
					{
						type: AssessmentsActionTypes.ADD_ASSESSMENT_DATA_LOG_FAILED
					};
				dispatch(addAssessmentLogFailedAction);

				return Promise.reject(error);
			}
		};
	},
	deleteAssessmentDataLog: (assessmentDataLog: AssessmentDataLog) => {
		return async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<DeleteAssessmentDataLogSuccessfulAction> => {
			const deleteAssessmentDataLogRequestedAction: DeleteAssessmentDataLogRequestedAction =
				{
					type: AssessmentsActionTypes.DELETE_ASSESSMENT_DATA_LOG_REQUESTED
				};
			dispatch(deleteAssessmentDataLogRequestedAction);
			try {
				const state = getState();
				const assessmentId =
					state.assessments.currentActiveAssessment?.id;
				if (!assessmentId) {
					throw new Error(
						"Assessment Data Log delete without currentActiveAssessment"
					);
				}
				await deleteAssessmentDataLog(
					assessmentId,
					assessmentDataLog.id
				);
				const updateBlockMapperRequestedAction: UpdateBlockMapperRequestedAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_REQUESTED
					};
				proposalBuilderStore.dispatch(updateBlockMapperRequestedAction);
				try {
					const state = getState();
					const newBlockMapper = await getUpdatedAssessmentBlocks(
						state,
						{
							riskMatrix: true,
							riskScore: true,
							riskListing: true
						}
					);
					const updateBlockMapperSuccessfulAction: UpdateBlockMapperSuccessfulAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_SUCCESSFUL,
							blockMapper: newBlockMapper
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperSuccessfulAction
					);
					const proposalBuilderState =
						proposalBuilderStore.getState();
					reloadPageToUpdateBlocks(
						proposalBuilderState.blocks.blockMapper
					);
				} catch (error) {
					const updateBlockMapperFailedAction: UpdateBlockMapperFailedAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_FAILED
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperFailedAction
					);

					return Promise.reject(error);
				}
				const deleteAssessmentDataLogSuccessfulAction: DeleteAssessmentDataLogSuccessfulAction =
					{
						type: AssessmentsActionTypes.DELETE_ASSESSMENT_DATA_LOG_SUCCESSFUL,
						deleteAssessmentLog: assessmentDataLog
					};
				return dispatch(deleteAssessmentDataLogSuccessfulAction);
			} catch (error) {
				const deleteAssessmentDataLogFailedAction: DeleteAssessmentDataLogFailedAction =
					{
						type: AssessmentsActionTypes.DELETE_ASSESSMENT_DATA_LOG_FAILED
					};
				dispatch(deleteAssessmentDataLogFailedAction);

				return Promise.reject(error);
			}
		};
	},
	getCategories: (assessmentId: string) => {
		return async (
			dispatch: Dispatch
		): Promise<AssessmentCategoriesSuccessfulAction> => {
			const assessmentCategoriesRequestedAction: AssessmentCategoriesRequestedAction =
				{
					type: AssessmentsActionTypes.ASSESSMENT_CATEGORIES_REQUESTED
				};
			dispatch(assessmentCategoriesRequestedAction);
			try {
				const assessmentCategoriesResponse = await getCategories(
					assessmentId
				);
				const assessmentCategoriesSuccessfulAction: AssessmentCategoriesSuccessfulAction =
					{
						type: AssessmentsActionTypes.ASSESSMENT_CATEGORIES_SUCCESSFUL,
						currentActiveAssessment: assessmentCategoriesResponse
					};
				return dispatch(assessmentCategoriesSuccessfulAction);
			} catch (error) {
				const assessmentCategoriesFailedAction: AssessmentCategoriesFailedAction =
					{
						type: AssessmentsActionTypes.ASSESSMENT_CATEGORIES_FAILED
					};
				dispatch(assessmentCategoriesFailedAction);

				return Promise.reject(error);
			}
		};
	},
	createCategory: (createCategoryRequest: CreateCategoryRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<CreateCategorySuccessfulAction> => {
			const createCategoryRequestedAction: CreateCategoryRequestedAction =
				{
					type: AssessmentsActionTypes.CREATE_ASSESSMENT_CATEGORY_REQUESTED
				};
			dispatch(createCategoryRequestedAction);
			try {
				const createCategoryResponse = await createCategory(
					createCategoryRequest
				);
				const createCategorySuccessfulAction: CreateCategorySuccessfulAction =
					{
						type: AssessmentsActionTypes.CREATE_ASSESSMENT_CATEGORY_SUCCESSFUL,
						currentActiveAssessment: createCategoryResponse
					};
				return dispatch(createCategorySuccessfulAction);
			} catch (error) {
				const createCategoryFailedAction: CreateCategoryFailedAction = {
					type: AssessmentsActionTypes.CREATE_ASSESSMENT_CATEGORY_FAILED
				};
				dispatch(createCategoryFailedAction);

				return Promise.reject(error);
			}
		};
	},
	updateCategory: (modifyCategoryRequest: ModifyCategoryRequest) => {
		return async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<UpdateCategorySuccessfulAction> => {
			const updateCategoryRequestedAction: UpdateCategoryRequestedAction =
				{
					type: AssessmentsActionTypes.UPDATE_ASSESSMENT_CATEGORY_REQUESTED
				};
			dispatch(updateCategoryRequestedAction);
			try {
				const updateCategoryResponse = await updateCategory(
					modifyCategoryRequest
				);
				const updateBlockMapperRequestedAction: UpdateBlockMapperRequestedAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_REQUESTED
					};
				proposalBuilderStore.dispatch(updateBlockMapperRequestedAction);
				try {
					const state = getState();
					const newBlockMapper = await getUpdatedAssessmentBlocks(
						state,
						{
							riskMatrix: true,
							riskScore: true,
							riskListing: true
						},
						[modifyCategoryRequest.issueId]
					);
					const updateBlockMapperSuccessfulAction: UpdateBlockMapperSuccessfulAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_SUCCESSFUL,
							blockMapper: newBlockMapper
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperSuccessfulAction
					);
					const proposalBuilderState =
						proposalBuilderStore.getState();
					reloadPageToUpdateBlocks(
						proposalBuilderState.blocks.blockMapper
					);
				} catch (error) {
					const updateBlockMapperFailedAction: UpdateBlockMapperFailedAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_FAILED
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperFailedAction
					);

					return Promise.reject(error);
				}
				const updateCategorySuccessfulAction: UpdateCategorySuccessfulAction =
					{
						type: AssessmentsActionTypes.UPDATE_ASSESSMENT_CATEGORY_SUCCESS,
						currentActiveAssessment: updateCategoryResponse
					};
				return dispatch(updateCategorySuccessfulAction);
			} catch (error) {
				const updateCategoryFailedAction: UpdateCategoryFailedAction = {
					type: AssessmentsActionTypes.UPDATE_ASSESSMENT_CATEGORY_FAILED
				};
				dispatch(updateCategoryFailedAction);

				return Promise.reject(error);
			}
		};
	},
	deleteCategory: (modifyCategoryRequest: ModifyCategoryRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<DeleteCategorySuccessfulAction> => {
			const deleteCategoryRequestedAction: DeleteCategoryRequestedAction =
				{
					type: AssessmentsActionTypes.DELETE_ASSESSMENT_CATEGORY_REQUESTED
				};
			dispatch(deleteCategoryRequestedAction);
			try {
				const deleteCategoryResponse = await deleteCategory(
					modifyCategoryRequest
				);
				const deleteCategorySuccessfulAction: DeleteCategorySuccessfulAction =
					{
						type: AssessmentsActionTypes.DELETE_ASSESSMENT_CATEGORY_SUCCESS,
						currentActiveAssessment: deleteCategoryResponse
					};
				return dispatch(deleteCategorySuccessfulAction);
			} catch (error) {
				const deleteCategoryFailedAction: DeleteCategoryFailedAction = {
					type: AssessmentsActionTypes.DELETE_ASSESSMENT_CATEGORY_FAILED
				};
				dispatch(deleteCategoryFailedAction);

				return Promise.reject(error);
			}
		};
	},
	reorderCategories: (reorderCategoriesRequest: ReorderCategoriesRequest) => {
		return async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<ReorderCategoriesSuccessfulAction> => {
			const reorderCategoriesRequestedAction: ReorderCategoryRequestedAction =
				{
					type: AssessmentsActionTypes.REORDER_ASSESSMENT_CATEGORIES_REQUESTED
				};
			dispatch(reorderCategoriesRequestedAction);
			try {
				const reorderCategoriesResponse = await reorderCategories(
					reorderCategoriesRequest
				);
				const updateBlockMapperRequestedAction: UpdateBlockMapperRequestedAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_REQUESTED
					};
				proposalBuilderStore.dispatch(updateBlockMapperRequestedAction);
				try {
					const state = getState();
					const newBlockMapper = await getUpdatedAssessmentBlocks(
						state,
						{
							riskMatrix: false,
							riskScore: false,
							riskListing: true
						}
					);
					const updateBlockMapperSuccessfulAction: UpdateBlockMapperSuccessfulAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_SUCCESSFUL,
							blockMapper: newBlockMapper
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperSuccessfulAction
					);
				} catch (error) {
					const updateBlockMapperFailedAction: UpdateBlockMapperFailedAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_FAILED
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperFailedAction
					);

					return Promise.reject(error);
				}
				const reorderCategoriesSuccessfulAction: ReorderCategoriesSuccessfulAction =
					{
						type: AssessmentsActionTypes.REORDER_ASSESSMENT_CATEGORIES_SUCCESS,
						currentActiveAssessment: reorderCategoriesResponse
					};
				return dispatch(reorderCategoriesSuccessfulAction);
			} catch (error) {
				const reorderCategoriesFailedAction: ReorderCategoryFailedAction =
					{
						type: AssessmentsActionTypes.REORDER_ASSESSMENT_CATEGORIES_FAILED
					};
				dispatch(reorderCategoriesFailedAction);

				return Promise.reject(error);
			}
		};
	},
	showMs365AssessmentsLoader: () => {
		return (dispatch: Dispatch): ShowMs365AssessmentsLoaderAction => {
			const showMs365AssessmentsLoaderAction: ShowMs365AssessmentsLoaderAction =
				{
					type: AssessmentsActionTypes.SHOW_MS365_ASSESSMENTS_LOADER
				};
			return dispatch(showMs365AssessmentsLoaderAction);
		};
	},
	hideMs365AssessmentsLoader: () => {
		return (dispatch: Dispatch): HideMs365AssessmentsLoaderAction => {
			const hideMs365AssessmentsLoaderAction: HideMs365AssessmentsLoaderAction =
				{
					type: AssessmentsActionTypes.HIDE_MS365_ASSESSMENTS_LOADER
				};
			return dispatch(hideMs365AssessmentsLoaderAction);
		};
	},
	openMs365AssessmentModal: () => {
		return (dispatch: Dispatch): Ms365AssessmentModalOpenedAction => {
			const ms365AssessmentsModalOpenedAction: Ms365AssessmentModalOpenedAction =
				{
					type: AssessmentsActionTypes.MS365_ASSESSMENTS_MODAL_OPENED
				};
			return dispatch(ms365AssessmentsModalOpenedAction);
		};
	},
	closeMs365AssessmentModal: () => {
		return (dispatch: Dispatch): Ms365AssessmentModalClosedAction => {
			const ms365AssessmentsModalClosedAction: Ms365AssessmentModalClosedAction =
				{
					type: AssessmentsActionTypes.MS365_ASSESSMENTS_MODAL_CLOSED
				};
			return dispatch(ms365AssessmentsModalClosedAction);
		};
	},
	getMs365Assessments: (clientId: string) => {
		return async (
			dispatch: Dispatch
		): Promise<Ms365AssessmentsListSuccessfulAction> => {
			const ms365AssessmentsListRequestedAction: Ms365AssessmentsListRequestedAction =
				{
					type: AssessmentsActionTypes.MS365_ASSESSMENTS_LIST_REQUESTED
				};
			dispatch(ms365AssessmentsListRequestedAction);
			try {
				const ms365AssessmentsListResponse = await getMs365Assessments(
					clientId
				);
				const ms365AssessmentsListSuccessfulAction: Ms365AssessmentsListSuccessfulAction =
					{
						type: AssessmentsActionTypes.MS365_ASSESSMENTS_LIST_SUCCESS,
						ms365AssessmentsList: ms365AssessmentsListResponse.data
					};
				return dispatch(ms365AssessmentsListSuccessfulAction);
			} catch (error) {
				const ms365AssessmentsListFailedAction: Ms365AssessmentsListFailedAction =
					{
						type: AssessmentsActionTypes.MS365_ASSESSMENTS_LIST_FAILED
					};
				dispatch(ms365AssessmentsListFailedAction);

				return Promise.reject(error);
			}
		};
	},
	resetMs365Assessments: () => {
		return (dispatch: Dispatch): Ms365AssessmentsResetAction => {
			const ms365AssessmentsResetAction: Ms365AssessmentsResetAction = {
				type: AssessmentsActionTypes.MS365_ASSESSMENTS_RESET
			};
			return dispatch(ms365AssessmentsResetAction);
		};
	},
	generateMs365Assessment: (clientId: string) => {
		return async (
			dispatch: Dispatch
		): Promise<GenerateMs365AssessmentSuccessfulAction> => {
			const ms365AssessmentRequestedAction: GenerateMs365AssessmentRequestedAction =
				{
					type: AssessmentsActionTypes.GENERATE_MS365_ASSESSMENT_REQUESTED
				};
			dispatch(ms365AssessmentRequestedAction);
			try {
				const ms365AssessmentResponse = await runMs365Assessment(
					clientId
				);
				const ms365AssessmentSuccessfulAction: GenerateMs365AssessmentSuccessfulAction =
					{
						type: AssessmentsActionTypes.GENERATE_MS365_ASSESSMENT_SUCCESS,
						currentActiveMs365Assessment: ms365AssessmentResponse
					};
				return dispatch(ms365AssessmentSuccessfulAction);
			} catch (error) {
				const ms365AssessmentFailedAction: GenerateMs365AssessmentFailedAction =
					{
						type: AssessmentsActionTypes.GENERATE_MS365_ASSESSMENT_FAILED
					};
				dispatch(ms365AssessmentFailedAction);

				return Promise.reject(error);
			}
		};
	},
	previewMs365Assessment: (clientId: string, ms365AssessmentId: string) => {
		return async (
			dispatch: Dispatch
		): Promise<PreviewMs365AssessmentSuccessfulAction> => {
			const previewMs365AssessmentRequestedAction: PreviewMs365AssessmentRequestedAction =
				{
					type: AssessmentsActionTypes.PREVIEW_MS365_ASSESSMENT_REQUESTED
				};
			dispatch(previewMs365AssessmentRequestedAction);
			try {
				const ms365AssessmentResponse = await previewMs365Assessment(
					clientId,
					ms365AssessmentId
				);
				const previewMs365AssessmentSuccessfulAction: PreviewMs365AssessmentSuccessfulAction =
					{
						type: AssessmentsActionTypes.PREVIEW_MS365_ASSESSMENT_SUCCESS,
						currentActiveMs365Assessment: ms365AssessmentResponse
					};
				return dispatch(previewMs365AssessmentSuccessfulAction);
			} catch (error) {
				const previewMs365AssessmentFailedAction: PreviewMs365AssessmentFailedAction =
					{
						type: AssessmentsActionTypes.PREVIEW_MS365_ASSESSMENT_FAILED
					};
				dispatch(previewMs365AssessmentFailedAction);

				return Promise.reject(error);
			}
		};
	},
	queueMs365AssessmentToAddToDoc: (ms365AssessmentId: string) => {
		return (dispatch: Dispatch): QueueMs65AssessmentToAddToDocAction => {
			const queueMs365AssessmentToAddToDocAction: QueueMs65AssessmentToAddToDocAction =
				{
					type: AssessmentsActionTypes.QUEUE_MS365_ASSESSMENT_TO_ADD_TO_DOC,
					ms365AssessmentId: ms365AssessmentId
				};
			return dispatch(queueMs365AssessmentToAddToDocAction);
		};
	},
	dequeueMs365AssessmentToAddToDoc: () => {
		return (dispatch: Dispatch): DequeueMs365AssessmentToAddToDocAction => {
			const dequeueMs365AssessmentToAddToDocAction: DequeueMs365AssessmentToAddToDocAction =
				{
					type: AssessmentsActionTypes.DEQUEUE_MS365_ASSESSMENT_TO_ADD_TO_DOC
				};
			return dispatch(dequeueMs365AssessmentToAddToDocAction);
		};
	},
	insertMs365AssessmentIntoDocument: (
		entityId: string,
		ms365AssessmentId: string
	) => {
		return async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<InsertMs365IntoDocSuccessfulAction> => {
			const insertMs365IntoDocRequestedAction: InsertMs365IntoDocRequestedAction =
				{
					type: AssessmentsActionTypes.INSERT_MS365_INTO_DOC_REQUESTED
				};
			dispatch(insertMs365IntoDocRequestedAction);
			try {
				const state = getState();
				const assessmentId =
					state.assessments.currentActiveAssessment?.id;
				if (!assessmentId) {
					throw new Error(
						"Inserting into assessment without currentActiveAssessment"
					);
				}

				const ms365AssessmentResponse =
					await insertMs365AssessmentIntoDocument(
						entityId,
						ms365AssessmentId
					);

				const updateBlockMapperRequestedAction: UpdateBlockMapperRequestedAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_REQUESTED
					};
				proposalBuilderStore.dispatch(updateBlockMapperRequestedAction);
				try {
					const state = getState();
					const newBlockMapper = await getUpdatedAssessmentBlocks(
						state,
						{
							riskMatrix: true,
							riskScore: true,
							riskListing: false
						}
					);
					const updateBlockMapperSuccessfulAction: UpdateBlockMapperSuccessfulAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_SUCCESSFUL,
							blockMapper: newBlockMapper
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperSuccessfulAction
					);
				} catch (error) {
					const updateBlockMapperFailedAction: UpdateBlockMapperFailedAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_FAILED
						};
					proposalBuilderStore.dispatch(
						updateBlockMapperFailedAction
					);

					return Promise.reject(error);
				}

				const insertMs365IntoDocSuccessfulAction: InsertMs365IntoDocSuccessfulAction =
					{
						type: AssessmentsActionTypes.INSERT_MS365_INTO_DOC_SUCCESS,
						currentActiveAssessment: ms365AssessmentResponse
					};
				return dispatch(insertMs365IntoDocSuccessfulAction);
			} catch (error) {
				const insertMs365IntoDocFailedAction: InsertMs365IntoDocFailedAction =
					{
						type: AssessmentsActionTypes.INSERT_MS365_INTO_DOC_FAILED
					};
				dispatch(insertMs365IntoDocFailedAction);

				return Promise.reject(error);
			}
		};
	},
	disconnectMs365Client: (clientId: string) => {
		return async (
			dispatch: Dispatch
		): Promise<DisconnectMs365ClientAction> => {
			try {
				const response = await disconnectMs365Client(clientId);
				const disconnectMs365ClientResponse: DisconnectMs365ClientAction =
					{
						type: ClientsActionTypes.CLIENT_DETAILS_SUCCESSFUL,
						currentActiveClient: response
					};
				return dispatch(disconnectMs365ClientResponse);
			} catch (error) {
				return Promise.reject(error);
			}
		};
	}
};

export default AssessmentsActionCreators;
